<template>
  <div class="flex flex-col gap-8" data-cy="contract-signed-preloaded-battery-offer-next-steps">
    <AtomText
      :text="t('subscription.contractSigned.nextSteps.title')"
      font-size="text-lg"
      font-style="font-semibold"
    />

    <NextStepItem
      icon-name="MailIcon"
      icon-color-variant="success"
      :title="t('subscription.contractSigned.preloadedBatteryOfferNextSteps.subscription.title')"
      :tags="[
        {
          value: t('subscription.contractSigned.preloadedBatteryOfferNextSteps.subscription.tag'),
          type: 'success',
        },
      ]"
      data-cy="contract-signed-preloaded-battery-offer-next-step-subscription"
    >
      <p>
        <AtomText is-tag="span" font-size="text-sm" :text="subscriptionParts[0]" /><AtomText
          is-tag="span"
          font-size="text-sm"
          font-style="font-semibold"
          :text="subscriptionParts[1]"
        /><AtomText is-tag="span" font-size="text-sm" :text="subscriptionParts[2]" />
      </p>
    </NextStepItem>

    <NextStepItem
      icon-name="FolderOpenIcon"
      icon-color-variant="success"
      :title="t('subscription.contractSigned.preloadedBatteryOfferNextSteps.enedisFile.title')"
      :tags="enedisFileTags"
      data-cy="contract-signed-preloaded-battery-offer-next-step-enedis-file"
    >
      <AtomText
        :text="
          isSelfInstalled
            ? t(
                'subscription.contractSigned.preloadedBatteryOfferNextSteps.enedisFile.descriptionSelfInstalled'
              )
            : t(
                'subscription.contractSigned.preloadedBatteryOfferNextSteps.enedisFile.descriptionInstaller'
              )
        "
        font-size="text-sm"
      />
    </NextStepItem>

    <NextStepItem
      icon-name="MyBatteryIcon"
      icon-color-variant="shy"
      :title="t('subscription.contractSigned.preloadedBatteryOfferNextSteps.battery.title')"
      :tags="[
        {
          value: t('subscription.contractSigned.preloadedBatteryOfferNextSteps.battery.tag'),
          type: 'default',
        },
      ]"
      data-cy="contract-signed-preloaded-battery-offer-next-step-battery"
    >
      <AtomText
        :text="t('subscription.contractSigned.preloadedBatteryOfferNextSteps.battery.description')"
        font-size="text-sm"
      />
    </NextStepItem>

    <AtomText
      :text="
        isSelfInstalled
          ? t('subscription.contractSigned.preloadedBatteryOfferNextSteps.disclaimerSelfInstalled')
          : t('subscription.contractSigned.preloadedBatteryOfferNextSteps.disclaimerInstaller')
      "
      font-size="text-xs"
      data-cy="contract-signed-preloaded-battery-offer-disclaimer"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useSubscriptionStore } from '@/stores';

import NextStepItem from '@/components/subscription/ContractSigned/NextStepItem.component.vue';
import type { NextStepTag } from '@/components/subscription/ContractSigned/NextStepItem.component.vue';

const { t, tm } = useI18n();

const subscriptionStore = useSubscriptionStore();
const { isSelfInstalled } = storeToRefs(subscriptionStore);

const subscriptionParts = computed(
  () =>
    tm(
      'subscription.contractSigned.preloadedBatteryOfferNextSteps.subscription.description'
    ) as string[]
);

const enedisFileTags = computed<NextStepTag[]>(() => [
  {
    value: t('subscription.contractSigned.preloadedBatteryOfferNextSteps.enedisFile.tag'),
    type: 'success',
  },
  {
    value: isSelfInstalled.value
      ? t(
          'subscription.contractSigned.preloadedBatteryOfferNextSteps.enedisFile.actionRequiredSelfInstalledTag'
        )
      : t(
          'subscription.contractSigned.preloadedBatteryOfferNextSteps.enedisFile.actionRequiredInstallerTag'
        ),
    type: 'warning',
    variant: 'icon',
    iconName: 'ExclamationIcon',
  },
]);
</script>

<style scoped></style>
